import Theme from '@adsk/alloy-react-theme';

export const emailOptionStyle = {
  width: '100%',
  display: 'inline-flex',
};

export const messageStyle = (addExistingUsers) => ({
  width: '23%',
  textAlign: 'right',
  color: addExistingUsers ? Theme.colors.charcoal500 : Theme.colors.red500,
});

export const emailStyle = (disabled) => ({
  width: '50%',
  ...(disabled && {
    color: Theme.colors.charcoal500,
    ...Theme.typography.ellipsis,
  }),
});

export const nameStyle = (disabled) => ({
  width: '27%',
  paddingRight: '10px',
  ...Theme.typography.ellipsis,
  ...(disabled && {
    color: Theme.colors.charcoal500,
  }),
});
